import React, { memo } from "react";
import useStyles from "../../styles";
import WrapperBody from "components/WrapperBody";
import FooterItem from "../FooterItem";

import { useTheme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { formatCash } from "config/constant";

const FooterCart = memo(props => {
	const classes = useStyles();
	const theme = useTheme();

	const { isShowKeyboard, wallet, disable, handleBuy } = props;

	return (
		!isShowKeyboard && (
			<WrapperBody
				container
				classes={{ root: classes.rootFooter }}
				id="footerCart"
			>
				<Grid classes={{ root: classes.totalBox }}>
					<FooterItem
						title="Tổng tiền"
						isBorder
						value={`${formatCash(wallet?.totalAmount)} Đ`}
					/>
					<FooterItem
						title="Tổng chiết khấu"
						isBorder
						value={`${formatCash(wallet?.finalDiscount)} Đ`}
					/>
					<FooterItem
						title="Thành tiền"
						value={`${formatCash(wallet?.finalAmount)} Đ`}
					/>
					<Grid classes={{ root: classes.text }}>
						Giá trên đã bao gồm thuế VAT
					</Grid>
				</Grid>
				<Grid
					style={{
						background: !disable
							? theme.palette.grey[900]
							: theme.palette.primary.main,
						color: !disable
							? theme.palette.common.white
							: theme.palette.text.contrastText,
						cursor: !disable ? "none" : "pointer"
					}}
					classes={{ root: classes.btnSubmit }}
					onClick={() => {
						disable && handleBuy();
					}}
				>
					Đặt hàng{" "}
					{wallet?.finalAmount > 0 && (
						<span>- {formatCash(wallet?.finalAmount)} Đ</span>
					)}
				</Grid>
			</WrapperBody>
		)
	);
});

export default FooterCart;
